import React, { useContext, useEffect, useState } from "react";
import { Box, Button, Typography, Dialog, DialogTitle, DialogContent, DialogActions } from "@material-ui/core";
import { AuthContext } from "../../context/Auth/AuthContext";
import api from "../../services/api";
import { toast } from "react-toastify";

export default function FabioHelpBanner({ ticketId }) {
  const { user, socket } = useContext(AuthContext);
  const [session, setSession] = useState(null), [busy, setBusy] = useState(false);
  const [confirm, setConfirm] = useState(false);
  useEffect(() => {
    let cancelled = false;
    const refresh = async () => {
      try { const r = await api.get("/fabio-workspace"); if (!cancelled) setSession(r.data.control.mode === "off" ? null : r.data.sessions.find(s => Number(s.ticketId) === Number(ticketId)) || null); } catch { /* The ordinary chat remains available. */ }
    };
    refresh(); const timer = setInterval(refresh, 10000), event = `company-${user.companyId}-fabio`;
    socket?.on(event, refresh);
    return () => { cancelled = true; clearInterval(timer); socket?.off(event, refresh); };
  }, [ticketId, user.companyId, socket]);
  if (!session || ["transferred", "closed"].includes(session.state)) return null;
  const help = async () => {
    setBusy(true);
    try {
      let version = session.version;
      if (!session.helperId) {
        const r = await api.post(`/fabio-workspace/sessions/${ticketId}/claim`, { version: session.version });
        version = r.data.version;
      }
      window.dispatchEvent(new CustomEvent("fabio-help-open", { detail: { ticketId, version, draft: session.draft || "" } }));
    } catch (e) { toast.error(e.response?.data?.error || "No fue posible tomar la ayuda de Fabio."); }
    finally { setBusy(false); setConfirm(false); }
  };
  return <Box px={2} py={1} display="flex" alignItems="center" justifyContent="space-between" style={{ borderBottom: "1px solid #517b9e", gap: 8 }}>
    <Typography variant="body2">{session.helperId ? `${session.helperName} está orientando a Fabio. ${session.state === "helping" ? "Atención pausada por un administrador." : "Fabio sigue respondiendo automáticamente."}` : "Fabio está atendiendo. Puede guiarlo en privado sin detenerlo."}</Typography>
    <Button color="primary" variant="outlined" disabled={busy || Boolean(session.processingAt) || Boolean(session.helperId && Number(session.helperId) !== Number(user.id))} onClick={() => session.helperId ? help() : setConfirm(true)}>{session.helperId ? "Abrir orientación" : "Orientar a Fabio"}</Button>
    <Dialog open={confirm} onClose={() => !busy && setConfirm(false)} maxWidth="xs" fullWidth>
      <DialogTitle>Orientar a Fabio en privado</DialogTitle>
      <DialogContent><Typography>Usted podrá darle indicaciones para sus próximas respuestas. El cliente no verá estas notas y Fabio seguirá atendiendo automáticamente. Los demás verán que usted lo está orientando.</Typography></DialogContent>
      <DialogActions><Button disabled={busy} onClick={() => setConfirm(false)}>Cancelar</Button><Button color="primary" variant="contained" disabled={busy} onClick={help}>Comenzar orientación</Button></DialogActions>
    </Dialog>
  </Box>;
}
